<template>
  <div class="search-bar">
    <a-input placeholder="Search" v-model="query" ref="searchBarInput">
      <a-icon slot="prefix" type="search" />
      <a-icon v-if="query" slot="suffix" type="close-circle" @click="emitEmpty" />
    </a-input>
  </div>
</template>

<script>
export default {
  data () {
    return {
      query: ''
    }
  },
  watch: {
    query (newValue) {
      this.$store.commit('setQuery', this.query)
    }
  },
  methods: {
    emitEmpty () {
      this.$refs.searchBarInput.focus()
      this.query = ''
    }
  }
}
</script>
<style scoped>
.search-bar .anticon-close-circle {
  cursor: pointer;
  color: #ccc;
  transition: color 0.3s;
  font-size: 12px;
}
.search-bar .anticon-close-circle:hover {
  color: #999;
}
.search-bar .anticon-close-circle:active {
  color: #666;
}
</style>


// WEBPACK FOOTER //
// src/components/SearchBar.vue